import createLucideIcon from '../createLucideIcon';

const ArrowUp = createLucideIcon('ArrowUpIcon', [
  ['line', { x1: '12', y1: '19', x2: '12', y2: '5', key: 'yrd7g6' }],
  ['polyline', { points: '5 12 12 5 19 12', key: '1y7d7k' }],
]);

export default ArrowUp;
